/**
 * External dependencies
 */
import React from 'react';
import {createContext, useContext, useCallback} from '@wordpress/element';
import {useSelect} from '@wordpress/data';

const EditorContext = createContext({
    isEditor: false,
    currentPostId: 0,
    currentView: '',
    previewData: {},
    getPreviewData: () => ({}),
});

export const useEditorContext = () => {
    return useContext(EditorContext);
};

export const EditorProvider = ({
                                   children,
                                   currentPostId = 0,
                                   previewData = {},
                                   currentView = '',
                                   size = 'small',
                                   isPreview = false,
                               }) => {
    const editingPostId = useSelect(
        (select) =>
            currentPostId
                ? currentPostId
                : select('core/editor')?.getCurrentPostId(),
        [currentPostId]
    );

    const getPreviewData = useCallback(
        (name) => {
            if (previewData && name in previewData) {
                return previewData[name];
            }
            return {};
        },
        [previewData]
    );

    const editorData = {
        isEditor: true,
        currentPostId: editingPostId,
        currentView,
        previewData,
        getPreviewData,
        isPreview,
        size
    };

    return (
        <EditorContext.Provider value={editorData}>
            {children}
        </EditorContext.Provider>
    );
};